module.exports = __webpack_public_path__ + "media/images/countryrect/gl-1f1cf2d5969165d6fd0ddce9c53bc5f7.svg";